import { AxiosRequestConfig } from "axios";

export enum LoginMethodEnum {
  Manual = "manual",
  Saml = "saml",
  Oauth = "oauth",
}

export interface LoginRequest {
  email: string;
  password: string;
}

export interface TokenResponse {
  access_token: string;
  refresh_token?: string;
  token_type: string;
  /** Password sign-in: the user must choose a new password before going on. */
  force_password_change?: boolean;
}

export interface RefreshTokenRequest {
  refresh_token: string;
}

export interface RegisterUserRequest {
  username: string;
  firstname: string;
  lastname: string;
  email: string;
  lang: string;
  mobile: string;
  summary: string;
  loginmethod: 'manual' | string;
  sync: boolean;
  locked: boolean;
  password: string;
  role_ids: number[];
}

export interface QueueItem {
  resolve: (value: unknown) => void;
  reject: (reason?: unknown) => void;
  config: AxiosRequestConfig;
}